const InstallmentCategory = () =>
  import(
    /* webpackChunkName: "InstallmentCategory" */ '@/view/pages/installment-category/InstallmentCategory.module.vue'
  )
const ListInstallment = () =>
  import(
    /* webpackChunkName: "ListInstallment" */ '@/view/pages/installment-category/list/index.vue'
  )
const AddInstallment = () =>
  import(/* webpackChunkName: "AddInstallment" */ '@/view/pages/installment-category/add/index.vue')
const UpdateInstallment = () =>
  import(
    /* webpackChunkName: "UpdateInstallment" */ '@/view/pages/installment-category/update/index.vue'
  )

export default [
  {
    path: 'installments',
    component: InstallmentCategory,
    children: [
      {
        path: '/',
        name: 'list-installment',
        component: ListInstallment,
        meta: {
          title: 'Danh sách dịch vụ trả góp - ClickBuy',
        },
      },
      {
        path: 'add',
        name: 'add-installment',
        component: AddInstallment,
        meta: {
          title: 'Thêm mới dịch vụ trả góp - ClickBuy',
        },
      },
      {
        path: 'update',
        name: 'update-installment',
        component: UpdateInstallment,
        meta: {
          title: 'Cập nhật dịch vụ trả góp - ClickBuy',
        },
      },
    ],
  },
]
